import React from "react";
import { Link } from "react-router-dom";
import { OCCASIONS } from "@/lib/constants";
export default function ShopByOccasion() {
  return (
    <main className="sq-container py-12" data-testid="occasion-page">
      <div className="sq-eyebrow">Curated</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Shop by Occasion</h1>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-5 mt-10">
        {OCCASIONS.map((o) => {
          const I = o.icon;
          return (
            <Link key={o.key} to={`/shop-by-occasion/${o.key}`} data-testid={`occasion-${o.key}`} className="group aspect-square border border-black/10 hover:border-squire-jeans flex flex-col items-center justify-center transition-colors">
              <I size={28} className="text-squire-jeans" />
              <div className="font-display text-xl mt-3">{o.label}</div>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
